import {
  Button,
  CreateAlert,
  InputWraper,
  Message,
  onError,
  useForm,
} from 'modules';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';

import { InputText } from '../../../components';
import { MoveBranch } from '../../../components/move-branch-popup';
import { PopupWraper } from '../../../components/popup';
import { TreeView } from '../../../components/tree-view';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import { withFranchiseWraper } from '../wraper';

export const PageFranchiseTree = withFranchiseWraper(() => {
  const [affiliation, setAffiliation] = useState(null as any);
  const [openMoveBranch, setOpenMoveBranch] = useState(null as any);
  const user = useSelector((state) => state.user);
  const [treeLists, setTreeLists] = useState([1]);

  useEffect(() => {
    AdminService.getAffiliation(25, user.userId)
      .then((res) => setAffiliation({ data: res }))
      .catch((err) => setAffiliation({ error: err.error }));

    // eslint-disable-next-line
  }, []);

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: [
      {
        name: 'email',
        validate: Yup.string().required('Email is required'),
      },
    ],
    onSubmit: async (values) => {
      await AdminService.getUserDetailByEmail(values.email)
        .then(async (res) => {
          if (res.success) {
            pushTreeLists(res.result.userId);
            await AdminService.getAffiliation(25, res.result.userId)
              .then((res) => {
                setAffiliation({ data: res });
              })
              .catch((err) => setAffiliation({ error: err.error }));
          } else {
            CreateAlert({
              message: 'Error when search.',
              type: 'danger',
            });
          }
        })
        .catch(onError);
    },
  });

  const onGetNewTree = (id: any, back: boolean) => {
    AdminService.getAffiliation(25, id)
      .then((res) => {
        setAffiliation({ data: res });
        if (!back) {
          pushTreeLists(id);
        }
      })
      .catch((err) => setAffiliation({ error: err.error }));
  };

  const onBack = () => {
    const list = treeLists;

    if (list.length > 1) {
      const back = list[list.length - 2];

      const item = list.pop();
      onGetNewTree(back, true);
    }
  };

  const pushTreeLists = (id: any) => {
    const treeList = treeLists;
    if (treeList[treeList.length - 1] != id) {
      treeList.push(id);
      setTreeLists(treeList);
    }
  };

  const openPopupMoveBranh = (nodeData: any) => {
    console.log(nodeData);
    setOpenMoveBranch(nodeData);
  };

  return (
    <>
      <div className='PageFranchiseTree'>
        <div className='col-sm-12'>
          <form className='blockLists' onSubmit={handleSubmit}>
            <div className='row'>
              {/* {affiliation} */}
              <div className='col-sm-3'>
                <InputWraper
                  // label={"Block Lists"}
                  inputProps={getInputProps('email')}
                  component={InputText}
                />
              </div>
              <div className='col-sm-3'>
                <Button
                  // className="mb20"
                  label='Search'
                  // onClick={()=>setTest("2")}
                  // isMiddle
                  // buttonType="warning"
                  className='btnBan'
                  type='submit'
                />
              </div>
              <div className='col-sm-6 text-right'>
                <Button
                  // className="mb20"
                  label='Back'
                  onClick={() => onBack()}
                  // isMiddle
                  buttonType='dark'
                  // className="btnBan"
                  // type="submit"
                />
              </div>
            </div>
          </form>
        </div>
        {(() => {
          if (!affiliation) return <Message type='loading' />;
          if (affiliation.error)
            return <Message type='error' message={affiliation.error.message} />;
          return (
            <TreeView
              onGetTree={(id) => {
                onGetNewTree(id, false);
              }}
              affiliate={affiliation.data}
              openPopupMoveBranh={openPopupMoveBranh}
            />
          );
        })()}
      </div>

      {openMoveBranch && (
        <PopupWraper
          center
          title='Move branch'
          onClose={() => setOpenMoveBranch(null)}
        >
          <MoveBranch
            data={openMoveBranch}
            onFinishEdit={() => {
              setOpenMoveBranch(null);
              window.location.reload();
            }}
          />
        </PopupWraper>
      )}
    </>
  );
});
